import { CrudModel } from "./_crud";

export class TreatmentModel extends CrudModel {
	constructor() {
		super("admin/treatment");
	}
}

export default new TreatmentModel();
